import { Metafield } from "@shopify/hydrogen/storefront-api-types";
import { header } from "../../../../setup/settings";

interface TaglineComponentProps {
    tagline?: Metafield;
}

const isValidTagline = (tagline: any): tagline is { span: string; p: string; useUrl?: boolean; url?: string } => {
    return (
        tagline &&
        typeof tagline === "object" &&
        Object.keys(tagline).length > 0 &&
        "span" in tagline &&
        "p" in tagline
    );
};

export default function TaglineComponent({ tagline }: TaglineComponentProps) {

    let parsedTagline: any;

    try {
        parsedTagline = tagline && typeof tagline.value === "string" ? JSON.parse(tagline.value) : tagline;
    } catch (error) {
        parsedTagline = undefined;
    }

    const validTagline = isValidTagline(parsedTagline) ? parsedTagline : undefined;

    return (
        <div className="NotificationPromo__text">
            {validTagline ? (
                <p>
                    <span>{validTagline.span}</span>
                    {validTagline.useUrl ? (
                        <a href={validTagline.url} target="_blank" rel="noopener noreferrer">
                            {validTagline.p}
                        </a>
                    ) : (
                        validTagline.p
                    )}
                </p>
            ) : (
                <p>
                    <span>{header.activityBar.span}</span> {header.activityBar.p}
                </p>
            )}
        </div>
    );
}